import { eventCountry } from './riskEventFeed';

export function reportDocumentLocation(reportId?: string, country?: string, isDailyMicro = false, reportDate?: string) {
    if (reportId?.startsWith('saved-intel:')) {
        const savedId = reportId.slice('saved-intel:'.length);
        return savedId && !savedId.includes('/') ? { path: ['saved_intel', savedId], dailyMicro: false } : null;
    }
    if (reportId)
        return { path: ['generated_reports', reportId], dailyMicro: false };
    if (!isDailyMicro)
        return null;
    const iso3 = eventCountry({ country });
    if (!iso3 || (reportDate && !/^\d{4}-\d{2}-\d{2}$/.test(reportDate)))
        return null;
    return {
        path: reportDate ? ['daily_country_analysis', iso3, 'reports', reportDate] : ['daily_country_analysis', iso3],
        dailyMicro: true,
    };
}
